import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';
import { Swiper, SwiperSlide, SwiperProps } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';
import Camera from './icons/Camera';
import CarFridge from './icons/CarFridge';
import Laptop from './icons/Laptop';
import Light from './icons/Light';
import Phone from './icons/Phone';
// import Projector from './icons/Projector';
import Refrigerator from './icons/Refrigerator';
import Screen from './icons/Screen';
// import Shower from './icons/Shower';
import Speaker from './icons/Speaker';
import WiFi from './icons/WiFi';
import NAS from './icons/NAS';
import PS5 from './icons/PS5';
import BabyFoodMaker from './icons/BabyFoodMaker';
import TV from './icons/TV';
import gtm from '@/utils/gtm';

type IconType = {
    text: string;
    icon: JSX.Element;
};

type ItemType = {
    label?: string;
    title: string;
    desc: string;
    img: [string, string];
    apps1: IconType[];
    apps2: IconType[];
    hrs: string;
};

export default function TheComp() {
    const { t } = useLang('theProduct');
    const items: ItemType[] = [
        {
            label: t('F_item1_label'),
            title: t('F_item1_title'),
            desc: t('F_item1_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1736734744661/6_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1736734744066/6_1_M.jpg'],
            apps1: [
                {
                    icon: <Camera />,
                    text: t('F_item1_app1_text1'),
                },
                {
                    icon: <Phone />,
                    text: t('F_item1_app1_text2'),
                },
                {
                    icon: <CarFridge />,
                    text: t('F_item1_app1_text3'),
                },
                {
                    icon: <Speaker />,
                    text: t('F_item1_app1_text4'),
                },
                {
                    icon: <Laptop />,
                    text: t('F_item1_app1_text5'),
                },
                {
                    icon: <Light />,
                    text: t('F_item1_app1_text6'),
                },
            ],
            apps2: [
                {
                    icon: <Phone />,
                    text: t('F_item1_app2_text1'),
                },
                {
                    icon: <Speaker />,
                    text: t('F_item1_app2_text2'),
                },
                {
                    icon: <Screen />,
                    text: t('F_item1_app2_text3'),
                },
                {
                    icon: <Light />,
                    text: t('F_item1_app2_text4'),
                },
                // {
                //     icon: <Refrigerator />,
                //     text: t('F_item1_app2_text5'),
                // },
            ],
            hrs: t('F_item1_hrs'),
        },
        {
            title: t('F_item2_title'),
            desc: t('F_item2_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1736734744480/6_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1736734744265/6_2_M.jpg'],
            apps1: [
                {
                    icon: <WiFi />,
                    text: t('F_item2_app1_text1'),
                },
                {
                    icon: <NAS />,
                    text: t('F_item2_app1_text2'),
                },
                {
                    icon: <TV />,
                    text: t('F_item2_app1_text3'),
                },
                {
                    icon: <Refrigerator />,
                    text: t('F_item2_app1_text4'),
                },
                {
                    icon: <PS5 />,
                    text: t('F_item2_app1_text5'),
                },
                {
                    icon: <BabyFoodMaker />,
                    text: t('F_item2_app1_text6'),
                },
            ],
            apps2: [
                {
                    icon: <WiFi />,
                    text: t('F_item2_app2_text1'),
                },
                {
                    icon: <NAS />,
                    text: t('F_item2_app2_text2'),
                },
                {
                    icon: <Refrigerator />,
                    text: t('F_item2_app2_text3'),
                },
            ],
            hrs: t('F_item2_hrs'),
        },
    ];

    return (
        <div className={styles.comp}>
            <EfSpec />
            <Swiper
                modules={[Pagination, Navigation]}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                spaceBetween={0}
                slidesPerView={'auto'}
                initialSlide={0}
                loop={true}
                className="items"
                onSlideChange={(swiper: SwiperProps | any) => {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'product_detail_page',
                        list_name: items[swiper?.realIndex || 0].title,
                        button_name: swiper?.realIndex === 0 ? '>' : '<',
                    });
                }}
            >
                {items?.map((item: ItemType, k: number) => (
                    <SwiperSlide className="item" key={k}>
                        <div className="item-info">
                            <p className="label" style={{ opacity: item?.label ? 1 : 0 }}>
                                {item?.label || 'null'}
                            </p>
                            <p className="title">{item.title}</p>
                            <p className="desc">{item.desc}</p>
                        </div>
                        <div className="item-box">
                            <div className="item-inner">
                                <ul className="item-app1 item-apps">
                                    {item.apps1?.map((app: IconType, m: number) => (
                                        <li className="item-app" key={k + '_' + m}>
                                            <div className="item-app-icon">{app.icon}</div>
                                            <p className="item-app-text">{app.text}</p>
                                        </li>
                                    ))}
                                </ul>
                                <p className="inner-title">{t('F_inner_title')}</p>
                                <ul className="item-app2 item-apps">
                                    {item.apps2?.map((app: IconType, m: number) => (
                                        <li className="item-app" key={k + '_' + m}>
                                            <div className="item-app-icon">{app.icon}</div>
                                            <p className="item-app-text">{app.text}</p>
                                        </li>
                                    ))}
                                </ul>
                                <div className="border"></div>
                                <div className="total">
                                    <p className="total-sum">{item.hrs}</p>
                                    <p className="backup">{t('F_backup')}</p>
                                </div>
                            </div>
                            <div className="item-img">
                                <EfImg pc={item.img[0]} h5={item.img[1]} />
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
